import { TReminder } from 'types/reminder';

import { CRMAPIBase } from '@api/crmApiBase';
import { ReminderListResp } from '@api/responseModels/reminder/reminderListResponse';
import { ReminderResp } from '@api/responseModels/reminder/reminderResponse';
import { RequestResult } from '@api/responseModels/requestResult';

export class ReminderGroup extends CRMAPIBase {
    async getReminderList(params: any): Promise<RequestResult<ReminderListResp>> {
        const result = await this.get<ReminderListResp>('/reminders', params);
        return result;
    }
    async createReminder(params: TReminder): Promise<RequestResult<ReminderResp>> {
        const result = await this.post<ReminderResp>('/reminders', params);
        return result;
    }
    async updateReminder(reminder: TReminder): Promise<RequestResult<ReminderResp>> {
        const result = await this.put<ReminderResp>(`/reminders/${reminder.id}`, reminder);
        return result;
    }
}
